import React from 'react';
import { View } from 'react-native';
import CornerBottomLeftSvg from '@assets/images/svg/doc-capture/corner-bottom-left.svg';

export interface CornerBottomLeftIconProps {
    size?: number;
}

export function CornerBottomLeftIcon({ size = 71 }: CornerBottomLeftIconProps) {
    return (
        <View style={{ width: size, height: size, justifyContent: 'center', alignItems: 'center' }}>
            <CornerBottomLeftSvg width={size} height={size} />
        </View>
    );
}

export default CornerBottomLeftIcon;

